import React from 'react';
import Table from 'UI/Table';
import { round, flatMap, map, sum } from 'lodash';
import ClusterFunctionTable from './ClusterFunctionTable';
import { filteredVMs, filteredClusterFunctions } from './Data';
import { humanizeGB, humanizeMB } from 'Decorators/SizeDecorator'

export const CustomerTable = ({ customers, filters, billing, vmsToUpdate, updateVMs }) => {
  const buildColumn = (field, humanize = true, humanizeFunction = humanizeGB) => ({
    accessor: (customer) => {
      const vms = filteredVMs(flatMap(customer.cluster_functions, cluster_function => cluster_function.vms), filters)
      const vmFields = map(vms, vm => parseInt(vm[field]))

      return round(sum(vmFields), 2)
    },
    Cell: ({ value }) => humanize ? humanizeFunction(value) : value,
    Footer: (row) => {
      const vms = filteredVMs(flatMap(customers, customer => flatMap(customer.cluster_functions, cluster_function => cluster_function.vms)), filters)
      const footerValue = round(sum(map(vms, vm => parseInt(vm[field]))), 2)

      return (
        <span>
          <strong>{row.column.Header}:</strong>{" "}
          {humanize ? humanizeFunction(footerValue) : footerValue.toLocaleString()}
        </span>
      )
    }
  });

  return (
    <Table {...{
      data: customers,
      columns: [
        { Header: 'Customer', accessor: 'customer_name', filterable: true, Footer: 'Totals', type: 'clientNameWithStatus' },
        {
          Header: 'VM Count',
          id: 'vm_count',
          type: 'number',
          accessor: customer => filteredVMs(flatMap(customer.cluster_functions, cluster_function => cluster_function.vms), filters).length,
          Footer: (row) => {
            const vms = filteredVMs(flatMap(customers, customer => flatMap(customer.cluster_functions, cluster_function => cluster_function.vms)), filters)

            return (
              <span>
                <strong>{row.column.Header}:</strong>{" "}
                {vms.length.toLocaleString()}
              </span>
            )
          }
        },
        { Header: 'Number of CPUs', id: 'customer_cpu', type: 'number', ...buildColumn('num_cpu', false) },
        { Header: 'Memory', id: 'customer_memory_gb', type: 'number', ...buildColumn('memory_gb') },
        { Header: 'Memory (Reserved)', id: 'customer_memory_reserved', type: 'number', ...buildColumn('memory_reservation_mb', true, humanizeMB) },
        { Header: 'Allocated Space', id: 'customer_allocated_space_gb', type: 'number', ...buildColumn('allocated_space_gb') },
        { Header: 'Provisioned Space', id: 'customer_provisioned_space_gb', type: 'number', ...buildColumn('provisioned_space_gb') },
        { Header: 'Used Space', id: 'customer_used_space_gb', type: 'number', ...buildColumn('used_space_gb') },
      ],
      collapseOnDataChange: false,
      defaultSorted: [{ id: 'customer_name', asc: true }],
      SubComponent: (row) => <ClusterFunctionTable {...{ cluster_functions: filteredClusterFunctions(row.original.cluster_functions, filters), filters, billing, vmsToUpdate, updateVMs, isTopLevel: false }} />
    }} />
  );
};
